{
  "forms": {
    "initialValues": {
      "milliCPU": 500,
      "memoryGB": "",
      "storageGB": 10,
      "serviceType": "single-node",
      "createWithData": "default",
      "regionCode": "us-east-1"
    },
    "defaultConfiguration": {
      "milliCPU": 500,
      "memoryGB": 2,
      "storageGB": 10,
      "regionCode": "us-east-1",
      "replicaCount": 0
    },
    "title": "Log in",
    "description": "By clicking \"Sign up\", I agree to the Terms of Service and acknowledge the Privacy Policy.",
    "buttonText": "Log in",
    "configuration": [
      {
        "value": 0.5,
        "name": "milliCPU",
        "label": "0.5 CPU",
        "label2": "2 GiB Memory",
        "cpu": 500,
        "memory": 2,
        "regionCode": "us-east-1"
      },
      {
        "value": 1,
        "name": "milliCPU",
        "label": "1 CPU",
        "label2": "4 GiB Memory",
        "cpu": 1000,
        "memory": 4,
        "regionCode": "us-east-1"
      },
      {
        "value": 2,
        "name": "milliCPU",
        "label": "2 CPU",
        "label2": "8 GiB Memory",
        "cpu": 2000,
        "memory": 8,
        "regionCode": "us-east-1"
      },
      {
        "value": 4,
        "name": "milliCPU",
        "label": "4 CPU",
        "label2": "16 GiB Memory",
        "cpu": 4000,
        "memory": 16,
        "regionCode": "us-east-1"
      },
      {
        "value": 8,
        "name": "milliCPU",
        "label": "8 CPU",
        "label2": "32 GiB Memory",
        "cpu": 8000,
        "memory": 32,
        "regionCode": "us-east-1"
      }
    ],
    "disk": {
      "name": "storageGB",
      "label": "Disk",
      "min": "0",
      "max": "30",
      "step": "1",
      "list": [
        10, 25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350,
        375, 400, 425, 450, 475, 500, 600, 700, 800, 900, 1000, 1500, 2000,
        2500, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 12000, 14000,
        16000
      ]
    },
    "inputs": [
      {
        "name": "email",
        "label": "Email",
        "placeholder": "Your email",
        "errorMessage": true
      },
      {
        "name": "password",
        "label": "Password",
        "placeholder": "Your password",
        "errorMessage": true
      }
    ]
  }
}
